import { useEffect } from "react";
import { useLocation, withRouter } from "react-router-dom";

function ScrollToTop({ history }) {
  const location = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location.pathname]);

  return null;
}

export default withRouter(ScrollToTop);
